import React from 'react'
import { Navigate } from 'react-router'

import { useAuth } from 'app/providers/auth/AuthProvider'

import { PATH_SEGMENT } from 'routes/pathSegments'
import { PathUtils } from 'routes/routes.utils'

export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isUnconfirmedDoctor } = useAuth()

  if (user) {
    return (
      <Navigate
        to={isUnconfirmedDoctor ? PathUtils.getValidateIdentity() : PATH_SEGMENT.ROOT}
        replace
      />
    )
  }

  return <>{children}</>
}
